// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var ProjectId = function (x) {
    return x;
};
var showProjectId = Data_Show.showInt;
var newtypeProjectId = new Data_Newtype.Newtype(function (n) {
    return n;
}, ProjectId);
var genericProjectId = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var eqProjectId = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordProjectID = new Data_Ord.Ord(function () {
    return eqProjectId;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordInt)(x)(y);
    };
});
var encodeJsonProjectId = Data_Argonaut_Encode_Class.encodeJsonInt;
var decodeJsonProjectId = Data_Argonaut_Decode_Class.decodeJsonInt;
module.exports = {
    ProjectId: ProjectId,
    eqProjectId: eqProjectId,
    ordProjectID: ordProjectID,
    newtypeProjectId: newtypeProjectId,
    genericProjectId: genericProjectId,
    encodeJsonProjectId: encodeJsonProjectId,
    decodeJsonProjectId: decodeJsonProjectId,
    showProjectId: showProjectId
};
